<!--Greeting row [ngClass]="{ 'platinum-surface': isPlatinumTheme }"-->
<div class="bg-white p-4 mb-4">
  <div class="grid gap-2 lg:grid-cols-[1fr_256px] items-start">
    <div class="flex flex-wrap items-center justify-between gap-4 w-full">
      <div
        class="flex w-full md:w-auto items-center justify-between md:justify-start"
        (click)="viewProfile()"
      >
        <div class="text-left">
          <h1 class="text-xl md:text-2xl font-bold text-dc-navy">
            {{ "BG_DASH.HELLO" | translate: { name: userName } }}
          </h1>
          <p class="text-gray-500">{{ userEmail }}</p>
        </div>
        <!-- Arrow only on mobile -->
        <span class="md:hidden text-2xl ml-2">
          <img
            src="/icons/svg/angle-right.svg"
            class="w-12 transition-transform rtl:rotate-180"
          />
        </span>
      </div>

      <!-- Balance + Recharge -->
      <div
        class="text-white px-4 py-2 w-full md:w-auto mt-3 md:mt-0"
        [ngClass]="showAvailableBalance ? 'bg-dc-navy':''"
      >
        <div class="flex items-center justify-between md:justify-start gap-6">
          <!-- Bank Guarantee -->
          @if (getBankGuaranteeBalance > 0) {
            <span class="font-medium inline-flex items-center gap-2">
              {{ "BANK_GUARANTEE_BALANCE" | translate }}
              <span class="text-yellow-300 inline-flex items-center">
                <i class="currency-icon currency-icon-aed-white mt-[5px]!"></i>
                {{ getBankGuaranteeBalance | number : "1.2-2" }}
              </span>
            </span>
          }

          @if (getBankGuaranteeBalance == 0 && showAvailableBalance) {  
            <span class="font-medium inline-flex items-center gap-2">
              {{ "AVAILABLE_BALANCE" | translate }}
              <span class="text-yellow-300 inline-flex items-center">
                <i class="currency-icon currency-icon-aed-white mt-[5px]!"></i>
                {{ getAdancePaymentBalance | number: "1.2-2" }}
              </span>
            </span>

            @if (showWalletBalance) {
              <app-button
                [label]="'RECHARGE' | translate"
                [classesName]="'card-edge-cut-white w-full md:w-auto'"
                (onBtnClick)="openRechargeModal()"
              ></app-button>
            }
          }
        </div>
      </div>
    </div>
    <div class="hidden md:flex justify-end">
      <!-- View profile button (only on desktop) -->
      <app-button
        [label]="'BUTTONS.PROFILE' | translate"
        [classesName]="
          isPlatinumTheme
            ? 'card-edge-cut-white platinum-profile-btn'
            : 'card-edge-cut-white'
        "
        (onBtnClick)="viewProfile()"
      ></app-button>
    </div>
  </div>
</div>

<!-- Platinum notification -->
<app-platinum-notification
  [platinumMember]="platinumMember"
  [targetApplicationCount]="platinumNoOfTargetApplications"
  [totalApplications]="completedApplicationsCount"
  (viewBenefits)="viewPlatinumBenefit()"
></app-platinum-notification>

<!-- Two-column layout (main + side)-->
<div class="grid gap-6 lg:grid-cols-[1fr_256px]">
  <!-- Left column -->
  <div class="space-y-6">
    <!-- events slider -->
    <app-event-slider></app-event-slider>

    <!-- company notice -->
    <app-company-info-notice
      [companyInfoLoading]="companyInfoLoading"
      [isCompanyInformationCompleted]="isCompanyInformationCompleted"
      (onBtnClick)="gotoCompanyInfo()"
    ></app-company-info-notice>
    <!--  Memberships card -->
    <section
      class="dc-collapse-card membership-card"
      [ngClass]="{ 'platinum-surface': isPlatinumTheme }"
    >
      @if (loadingUserData) {
        <!-- Loader Placeholder -->
        <app-skeleton-loader></app-skeleton-loader>
      } @else {
        <div class="dc-collapse-card-heading">
          <h3>
            <img [src]="getIconPath('svg/user.svg')" />
            <span>
              {{
                "BG_DASH.MEMBERSHIPS_TITLE"
                  | translate: { count: userAccounts.length }
              }}</span
            >
          </h3>
          <span>
            <img
              src="/icons/svg/angle-right.svg"
              class="transition-transform rtl:rotate-180"
            />
          </span>
        </div>

        <div class="divide-y">
          <div class="px-3 pt-2">
            <div class="mb-4">
              <app-validation-message
                [type]="'info'"
                [showCloseIcon]="false"
                [showTypeIcon]="true"
                [content]="{
                  message: 'BG_DASH.PRIMARY_MEMBERSHIP_INFO',
                }"
                (onBtnClick)="(false)"
              ></app-validation-message>
            </div>
            <div class="flex flex-wrap items-center gap-4 sm:gap-6 text-sm font-medium">
              <button
                type="button"
                class="pb-3 border-b-2 border-transparent transition-colors"
                (click)="changeMembershipTab('members')"
                (dblclick)="onMembersTabDblClick($event)"
                [ngClass]="{
                  'text-dc-navy border-dc-navy font-semibold':
                    activeMembershipTab === 'members',
                  'text-dc-gray-light': activeMembershipTab !== 'members',
                }"
              >
                {{
                  "BG_DASH.MEMBERS_TAB"
                    | translate: { count: memberAccountsCount }
                }}
              </button>
              <button
                type="button"
                class="pb-3 border-b-2 border-transparent transition-colors"
                (click)="changeMembershipTab('nonMembers')"
                [ngClass]="{
                  'text-dc-navy border-dc-navy font-semibold':
                    activeMembershipTab === 'nonMembers',
                  'text-dc-gray-light': activeMembershipTab !== 'nonMembers',
                }"
              >
                {{
                  "BG_DASH.NON_MEMBERS_TAB"
                    | translate: { count: nonMemberAccountsCount }
                }}
              </button>
              <div class="w-full md:w-auto ltr:md:ml-auto rtl:md:mr-auto md:min-w-[320px] lg:min-w-[360px] pb-2 md:pb-3">
                <div class="relative">
                  <span class="pointer-events-none absolute top-1/2 -translate-y-1/2 text-dc-navy ltr:right-3 rtl:left-3">
                    <i class="fas fa-search text-lg"></i>
                  </span>
                  <input
                    type="text"
                    class="w-full border border-dc-navy ltr:pr-10 ltr:pl-3 rtl:pl-10 rtl:pr-3 py-2 text-sm text-dc-navy focus:outline-none ltr:text-left rtl:text-right"
                    [placeholder]="
                      'BG_DASH.MEMBER_FILTER_PLACEHOLDER' | translate
                    "
                    (input)="onMemberFilterInput($event)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="overflow-auto dashboard">
            @if (!pagedAccounts.length) {
              <div class="py-6 text-center text-sm text-dc-gray-light">
                {{ "NO_RECORD_FOUND" | translate }}
              </div>
            } @else {
              <div class="space-y-4 mt-4 p-2">
                @for (member of pagedAccounts; track member) {
                  <!-- NON MEMBERS TAB -->
                  @if (activeMembershipTab === "nonMembers") {
                    <div class="border-b border-gray-200 px-3">
                      <!-- Name / Benefit -->
                      @if (!showBenefit) {
                        <h2
                          class="text-dc-navy font-semibold text-xl cursor-pointer"
                        >
                          {{
                            lang == "en"
                              ? member["DC Name English"]
                              : member["DC Name Arabic"]
                          }}
                        </h2>
                        <!-- Info Grid -->
                        <div
                          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 text-dc-navy text-base mt-2"
                        >
                          <div class="mb-1 text-dc-navy">
                            {{ member["Account Type Code"] }}
                            <div class="font-semibold">
                              {{ member.CSN ? member.CSN : "-" }}
                            </div>
                          </div>

                          <div>
                            <button
                              type="button"
                              class="underline underline-offset-4 text-lg text-dc-dark-blue"
                              (click)="showBenefit = !showBenefit"
                            >
                              {{ "BG_DASH.SEE_BENEFITS" | translate }}
                            </button>
                          </div>

                          <!-- Actions -->
                          <div
                            class="flex flex-wrap gap-3 col-span-3 justify-end mb-3 sm:mb-0"
                          >
                            @if (canShowMemberActions(member)) {
                              @if (accountId !== member.Id) {
                                <app-button
                                  [label]="'BUTTONS.SET_PRIMARY' | translate"
                                  (onBtnClick)="setAsPrimaryAccount(member)"
                                />
                              } @else {
                                <app-button
                                  [label]="'BG_DASH.IS_PRIMARY' | translate"
                                  [classesName]="'card-edge-cut-white'"
                                  (onBtnClick)="(false)"
                                  [iconClass]="
                                    'fa-solid fa-check-circle text-1xl text-dc-green'
                                  "
                                />
                              }
                              <app-button
                                [label]="
                                  'BUTTONS.APPLY_FOR_MEMBERSHIP' | translate
                                "
                                classesName="card-edge-cut-white"
                                (onBtnClick)="applyMembership()"
                              />
                            }
                          </div>
                        </div>
                      }
                      @if (showBenefit) {
                        <div class="mb-4">
                          <div class="font-semibold text-dc-black">
                            {{ "BG_DASH.BENEFIT_TITLE" | translate }}
                          </div>
                          <div class="text-dc-black">
                            {{ "BG_DASH.BENEFIT_DESC" | translate }}
                          </div>
                          <ul class="list-disc pl-5 mt-2">
                            <li>
                              {{ "BG_DASH.BENEFIT_EXCLUSIVE" | translate }}
                            </li>
                            <li>
                              {{ "BG_DASH.BENEFIT_DISCOUNT" | translate }}
                            </li>
                          </ul>
                          <button
                            type="button"
                            class="underline underline-offset-4 text-base text-dc-dark-blue mt-4"
                            (click)="showBenefit = !showBenefit"
                          >
                            {{ "BUTTONS.CLOSE" | translate }}
                          </button>
                        </div>
                      }
                    </div>
                  }

                  <!-- MEMBERS TAB -->
                  @else {
                    <div class="border-b border-gray-200 px-3">
                      <div class="flex flex-col sm:flex-row sm:items-start gap-2">
                        <div>
                          <h2
                            class="text-dc-navy font-semibold text-xl cursor-pointer"
                            (click)="viewMembership(member)"
                          >
                            {{
                              lang == "en"
                                ? member["DC Name English"]
                              : member["DC Name Arabic"]
                            }}
                          </h2>
                          <div class="sm:hidden mt-1">
                           <span
                            class="px-1"
                            [ngClass]="{
                              'dc-status-negative':
                                member['Account Status'] === 'Inactive' ||
                                member['Account Status'] === 'Cancelled',
                              'dc-status-warning':
                                member['Account Status'] === 'Active - Renew',
                              'dc-status-active':
                                member['Account Status'] !== 'Inactive' &&
                                member['Account Status'] !== 'Cancelled' &&
                                member['Account Status'] !== 'Active - Renew'
                            }"
                          >
                            {{ member["Account Status"] }}
                          </span>
                          </div>
                        </div>
                         <div class="p-1 hidden sm:block">
                          <span
                            class="px-1"
                            [ngClass]="{
                              'dc-status-cancelled':
                                getMemberDisplayStatus(member) === 'Inactive' ||
                                getMemberDisplayStatus(member) === 'Cancelled',
                              'dc-status-negative': getMemberDisplayStatus(member) === 'Expired',
                              'dc-status-warning':
                                getMemberDisplayStatus(member) === 'Active - Renew',
                              'dc-status-active':
                                getMemberDisplayStatus(member) !== 'Expired' &&
                                getMemberDisplayStatus(member) !== 'Inactive' &&
                                getMemberDisplayStatus(member) !== 'Cancelled' &&
                                getMemberDisplayStatus(member) !== 'Active - Renew'
                            }"
                            title="{{ member['Account Status'] }}"
                          >
                            {{ getMemberDisplayStatus(member) }}
                          </span>
                        </div>
                      </div>

                      <!-- Info Grid -->
                      <div
                        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 text-dc-navy text-base mt-2 mb-2"
                      >
                        <div class="mb-1">
                          {{ "MEM.NUM" | translate }}
                          <div class="font-semibold text-base">
                            {{ member.CSN ? member.CSN : "-" }}
                          </div>
                        </div>
                        <div class="mb-1">
                          {{ "MEM.LIC" | translate }}
                          <div class="font-semibold">
                            {{
                              member["License Number"]
                                ? member["License Number"]
                                : "-"
                            }}
                          </div>
                        </div>
                        <div class="mb-1">
                          {{ "MEM.EXP" | translate }}
                          <div class="font-semibold">
                            {{
                              member?.["DC Expiry Date"]
                                ? (member?.["DC Expiry Date"]
                                  | date: "dd MMMM yyyy")
                                : "-"
                            }}
                          </div>
                        </div>

                        <!-- Actions -->
                        <div class="mb-1">
                          @if (member.CSN && ( member['Account Status'] != 'Inactive' &&
                                member['Account Status'] != 'Cancelled')) {
                            <a
                              class="underline underline-offset-4 text-base text-dc-dark-blue"
                              (click)="manageUsers(member)"
                            >
                              {{ "BG_DASH.MANAGE_USERS" | translate }}
                            </a>
                          }
                        </div>

                        <div class="flex flex-wrap gap-3 justify-end">
                          @if (canShowMemberActions(member)) {
                            @if (accountId !== member.Id) {
                              <app-button
                                [label]="'BUTTONS.SET_PRIMARY' | translate"
                                (onBtnClick)="setAsPrimaryAccount(member)"
                              />
                            } @else {
                              <app-button
                                [label]="'BG_DASH.IS_PRIMARY' | translate"
                                [classesName]="'card-edge-cut-white'"
                                (onBtnClick)="(false)"
                                [iconClass]="
                                  'fa-solid fa-check-circle text-1xl text-dc-green'
                                "
                              />
                            }
                          }
                        </div>
                      </div>

                      <!-- Actions -->
                      <!-- <div class="flex flex-wrap gap-4 items-center mt-2 mb-4">
                @if (member["Account Status"] !== 'Cancelled') { @if (accountId
                !== member.Id) {
                <app-button
                  [label]="'BUTTONS.SET_PRIMARY' | translate"
                  (onBtnClick)="setAsPrimaryAccount(member)"
                />
                } @else {

                <app-button
                  [label]="'BG_DASH.IS_PRIMARY' | translate"
                  [classesName]="'card-edge-cut-white'"
                  (onBtnClick)="(false)"
                  [iconClass]="
                    'fa-solid fa-check-circle text-1xl text-dc-green'
                  "
                />
                } } @if (member.CSN) {
                <app-button
                  classesName="card-edge-cut-white"
                  [label]="'BG_DASH.MANAGE_USERS' | translate"
                  (onBtnClick)="manageUsers(member)"
                />
                } @if (member['DC Certificate URL']) {
                <app-button
                  classesName="card-edge-cut-white"
                  [label]="'BUTTONS.MEMBERSHIP_CERTIFICATE' | translate"
                  [iconClass]="'fas fa-download'"
                  (onBtnClick)="openDownloadLink(member)"
                />
                }               
              </div> -->
                      <!-- Access Request Notification -->
                      @if (
                        accessReqCount > 0 &&
                        accountCSN == member.CSN &&
                        isPrimaryUser
                      ) {
                        <div class="access-req-notification mt-4">
                          <span>
                            {{
                              "BG_DASH.ACCESS_REQUEST_MSG"
                                | translate: { count: accessReqCount }
                            }}
                          </span>

                          <div class="flex gap-4 ltr:ml-auto rtl:mr-auto">
                            <button
                              class="underline"
                              (click)="viewMembership(member)"
                            >
                              {{ "BUTTONS.VIEW_DETAILS" | translate }}
                            </button>

                            <button
                              class="w-4 h-4"
                              (click)="accessReqCount = 0"
                            >
                              <img src="/icons/svg/close.svg" />
                            </button>
                          </div>
                        </div>
                      }

                      <!-- Validation -->
                      @if (invalidMembershipAccountId === member.Id) {
                        <app-validation-message
                          class="mt-4"
                          type="error"
                          [showCloseIcon]="true"
                          [content]="{
                            message: 'BG_DASH.MEMBERSHIP_NOT_APPROVED_MESSAGE',
                          }"
                          (closed)="dismissMembershipNotApprovedMessage()"
                        />
                      }
                    </div>
                  }
                }
              </div>
            }
            @if (totalPages > 1) {
              <div class="mt-4 mb-4 flex justify-center">
                <app-pagenation
                  [showInfo]="false"
                  [data]="{
                    currentPage: currentPage,
                    totalPages: totalPages
                  }"
                  (pageChangeEvent)="goToPage($event)"
                ></app-pagenation>
              </div>
            }

            <!-- Other business message  -->
            @if (showAddBusinessMessage) {
              <div class="px-3 pt-2">
                <app-validation-message
                  [type]="'info'"
                  [content]="{
                    title: 'BG_DASH.OTHER_BUSINESS' | translate,
                    message: '',
                  }"
                  [showTypeIcon]="false"
                  [showCloseIcon]="false"
                  [showbutton]="true"
                  [buttonText]="'BUTTONS.ADD_MORE_BUSINESS' | translate"
                  (onBtnClick)="gotoAddBusiness()"
                  (closed)="showAddBusinessMessage = false"
                ></app-validation-message>
              </div>
            }
          </div>
        </div>
      }
    </section>

    <!--  Applications card -->
    <!-- <section
      class="dc-collapse-card"
      [ngClass]="{ 'platinum-surface': isPlatinumTheme }"
    >
      <div class="dc-collapse-card-heading">
        <h3>
          <img [src]="getIconPath('svg/flag.svg')" />
          <span>
            {{
              "BG_DASH.APPS_TITLE" | translate: { count: applications.length }
            }}
          </span>
        </h3>
        <span class="flex" (click)="gotoApplications()">
          <img
            src="/icons/svg/angle-right.svg"
            class="transition-transform rtl:rotate-180"
          />
        </span>
      </div>

      <div class="divide-y">
        <div class="overflow-auto dashboard">
          <table class="dc-table">
            <thead></thead>
            <tbody class="">
              @if (loader) {
                <app-skeleton-loader></app-skeleton-loader>
              } @else {
                @if (applications.length < 1) {
                  <tr>
                    <td>
                      <span class="text-dc-black font-semibold">
                        {{ "BG_DASH.NOT_APPLIED_SERVICE" | translate }}
                        <br />
                        {{ "BG_DASH.AVAILABLE_SERVICES" | translate }}
                      </span>
                    </td>

                    <td class="lg:text-end">
                      <app-button
                        [label]="'BUTTONS.APPLY_SERVICE' | translate"
                        [classesName]="'card-edge-cut-white min-w-[10rem]'"
                        (onBtnClick)="applyForServices()"
                      ></app-button>
                    </td>
                  </tr>
                }
                @for (application of applications; track $index) {
                  <tr>
                    <td>
                      <span class="block font-semibold text-dc-black">{{
                        application["SR Type"]
                      }}</span>
                      <span class="block text-dc-gray-light">
                        {{ application["SR Sub Type"] }}
                      </span>
                      <span class="block text-base">
                        {{ application["SR Number"] }}
                      </span>
                    </td>
                    <td>
                      {{ application["DC Created"] | date: "dd-MMM-yyyy" }}
                    </td>
                    <td>
                      <span
                        class="dc-status"
                        [class]="getStatusClass(application.Status)"
                      >
                        {{ application.Status }}
                      </span>
                    </td>
                    <td>
                      <div
                        class="flex justify-end lg:justify-end items-center gap-3"
                      >
                        @if (
                          (application.Status == srStatus.Paid ||
                            application.Status == srStatus.Closed ||
                            application.Status ==
                              srStatus.AwaitingCarnetReturn) &&
                          isValidHttpsUrl(application["DCDownloadURL"])
                        ) {
                          <app-button
                            [label]="
                              'BUTTONS.MEMBERSHIP_CERTIFICATE' | translate
                            "
                            [classesName]="
                              'card-edge-cut-white px-1 tracking-tight min-w-[10rem]'
                            "
                            (onBtnClick)="
                              openDownloadLink(application['DCDownloadURL'])
                            "
                            [iconClass]="'fas fa-download'"
                          ></app-button>
                        } @else {
                          @if (
                            application.Status == srStatus.Paid ||
                            application.Status == srStatus.AwaitingCarnetReturn
                          ) {
                            <app-button
                              [label]="'CERTIFICATE_INPROGRESS' | translate"
                              [classesName]="
                                'card-edge-cut-white px-1 tracking-tight min-w-[10rem]'
                              "
                              (onBtnClick)="(false)"
                              [iconClass]="'fas fa-spinner fa-spin'"
                            ></app-button>
                          }
                        }
                        @if (
                          application.Status ===
                          srStatus.ApprovedAndPaymentAwaited
                        ) {
                          <app-button
                            [label]="'BUTTONS.PAY' | translate"
                            [classesName]="
                              'btn-edge-cut tracking-tight min-w-[10rem]'
                            "
                            (onBtnClick)="gotoPaymentPage(application)"
                          ></app-button>
                        }
                        <app-button
                          [label]="
                            application['Status'] === srStatus.Draft
                              ? ('BUTTONS.CONTINUE_APP' | translate)
                              : ('BUTTONS.VIEW_APP' | translate)
                          "
                          [classesName]="
                            'card-edge-cut-white tracking-tight min-w-[10rem]'
                          "
                          (onBtnClick)="openApplication(application)"
                        ></app-button>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </section> -->

    <!--  Statics card -->
    <section
      class="dc-collapse-card"
      [ngClass]="{ 'platinum-surface': isPlatinumTheme }"
    >
      <div class="dc-collapse-card-heading">
        <h3>
          <img [src]="getIconPath('svg/warning-blue.svg')" />
          <span>
            {{
              "BG_DASH.STAT_TITLE" | translate: { count: applications.length }
            }}
          </span>
        </h3>
        <span (click)="gotoStaticsPage()">
          <img
            src="/icons/svg/angle-right.svg"
            class="transition-transform rtl:rotate-180"
          />
        </span>
      </div>

      <div class="divide-y">
        @if (accountCSN && userLoginName) {
          <app-dashboard-statics
            [csn]="accountCSN"
            [loginName]="userLoginName"
          ></app-dashboard-statics>
        } @else {
          <span class="block text-base p-5">
            {{ "NO_RECORD_FOUND" | translate }}
          </span>
        }
      </div>
    </section>
  </div>

  <!-- Right column (side widgets) -->
  <app-right-sidebar [platinumMember]="platinumMember"></app-right-sidebar>
</div>

<app-notice-modal
  [(isOpen)]="showNoticeModal"
  [imageSrc]="dashboardNotice.imageSrc"
  [imageAlt]="dashboardNotice.imageAlt"
  [maxWidth]="'500px'"
  (closed)="closeNoticeModal()"
></app-notice-modal>

@if (openTourModal) {
  <div class="dc-modal">
    <div class="dc-modal-container bg-white min-w-3xs! max-w-[450px]!">
      <div class="text-center">
        <h2 class="text-2xl font-semibold text-dc-navy">
          {{ "TOUR.WELCOME" | translate: { name: userName } }}
        </h2>
        <p class="p-5">
          {{ "TOUR.WELCOME_TEXT" | translate }}
        </p>
      </div>
      <div class="flex gap-3 justify-center">
        <app-button
          type="button"
          classesName="card-edge-cut-white"
          [label]="'TOUR.REMINDE_LATER' | translate"
          (onBtnClick)="remindeLater()"
        ></app-button>
        <app-button
          type="button"
          classesName="btn-edge-cut"
          [label]="'TOUR.START_TOUR' | translate"
          (onBtnClick)="startTour()"
        ></app-button>
      </div>
    </div>
  </div>
}
@if (rechargeModal) {
  <div class="dc-modal">
    <div class="dc-modal-container">
      <button
        class="modal-x-button"
        type="button"
        (click)="rechargeModal = false"
      >
        <i class="fas fa-close"></i>
      </button>
      <h1 class="section-heading">
        {{ "PAYMENT_SRVICE" | translate }}
      </h1>
      <!-- content -->
      <app-payment-service
        [(isOpen)]="rechargeModal"
        (onBtnClick)="(false)"
      ></app-payment-service>
    </div>
  </div>
}

<!-- Modal for verify email address -->
@if (verifyEmailModal) {
  <div class="dc-modal">
    <div class="dc-modal-container max-w-[500px]! bg-white">
      <!-- <button class="modal-x-button" type="button" (click)="onVerifyEmailClosed()">
        <i class="fas fa-close"></i>
      </button> -->
      <div class="text-dc-black">
        <h2 class="text-xl font-semibold text-dc-navy mb-4">
          {{ "BG_DASH.EMAIL_CONFIRM.TITLE" | translate }}
        </h2>

        <div class="space-y-5 text-lg">
          <p>
            {{ "BG_DASH.EMAIL_CONFIRM.OTP_MESSAGE_PREFIX" | translate }}
            <span class="font-semibold text-dc-navy">{{ userEmail }}</span>
          </p>
          <div class="pt-2 pb-3">
            @if (!verifyEmailOtpLoader) {
              <app-verify-email
                [LoginName]="userLoginName"
                [EmailAddr]="userEmail"
                [embedded]="true"
                (verified)="onVerifyEmailSuccess()"
              ></app-verify-email>
            } @else {
              <app-button
                type="button"
                classesName="btn-edge-cut min-w-[240px]"
                [label]="'PLEASE_WAIT' | translate"
                [disabled]="true"
              ></app-button>
            }
          </div>

          <p class="pt-1">
            {{ "BG_DASH.EMAIL_CONFIRM.UPDATE_PREFIX" | translate }}
            <span class="font-semibold text-dc-navy">
              <span class="font-semibold cursor-pointer" (click)="gotoProfileFromDuplicateIdentity()">
                {{ "BG_DASH.DUPLICATE_IDENTITY.UPDATE_BUTTON" | translate }}
              </span>
            </span>
          </p>
          <p class="pt-1">
            {{ "BG_DASH.DUPLICATE_IDENTITY.ASSISTANCE" | translate }}
            <a class="font-semibold text-dc-navy underline underline-offset-4" href="mailto:customercare@dubaichamber.com">
              customercare&#64;dubaichamber.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
}

@if (duplicateIdentityModal) {
  <div class="dc-modal">
    <div class="dc-modal-container max-w-[760px]! bg-white">
      <!-- <div class="border-t-6 border-dc-navy -mx-6 -mt-6 mb-5"></div> -->

      <h2 class="text-xl font-semibold text-dc-navy mb-3">
        {{ "BG_DASH.DUPLICATE_IDENTITY.TITLE" | translate }}
      </h2>

      <div class="inline-flex items-center rounded-full bg-red-100 px-3 py-1 text-xs font-semibold text-red-600 mb-4">
        {{ "BG_DASH.DUPLICATE_IDENTITY.RISK" | translate }}
      </div>

        <div class="space-y-3 text-dc-black">
          <p class="text-sm!">
            {{ "BG_DASH.DUPLICATE_IDENTITY.EMAIL_MESSAGE_PREFIX" | translate }}
            <span class="font-semibold text-dc-navy">{{ duplicateIdentityEmail }}</span>
            {{ "BG_DASH.DUPLICATE_IDENTITY.EMAIL_MESSAGE_SUFFIX" | translate }}
          </p>
          <p class="text-sm!">
            {{ "BG_DASH.DUPLICATE_IDENTITY.CUTOFF_PREFIX" | translate }}
            <span class="font-semibold text-dc-navy">
              {{ "BG_DASH.DUPLICATE_IDENTITY.CUTOFF_DATE" | translate }}
            </span>.
          </p>
          <p class="text-sm! font-semibold text-red-500!">
            {{ "BG_DASH.DUPLICATE_IDENTITY.ACTION_REQUIRED" | translate }}
          </p>
      </div>

      <div class="mt-5 max-h-[150px] overflow-y-auto rounded border border-gray-200">
        <table class="w-full border-collapse text-left">
          <thead class="bg-gray-100 text-dc-navy">
            <tr>
              <th class="px-3 py-3 w-16">
                {{ "BG_DASH.DUPLICATE_IDENTITY.TABLE_NO" | translate }}
              </th>
              <th class="px-3 py-3">
                {{ "BG_DASH.DUPLICATE_IDENTITY.TABLE_NAME" | translate }}
              </th>
              <th class="px-3 py-3">
                {{ "BG_DASH.DUPLICATE_IDENTITY.TABLE_USERNAME" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (user of duplicateIdentityUsers; track user.userName; let index = $index) {
              <tr class="border-t border-gray-200">
                <td class="px-3 py-3 text-sm!">{{ index + 1 }}</td>
                <td class="px-3 py-3 text-sm!">{{ user.name }}</td>
                <td class="px-3 py-3 text-sm!">{{ user.userName }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="mt-5 space-y-4 text-lg text-dc-black">
        <p>
          {{ "BG_DASH.DUPLICATE_IDENTITY.INSTRUCTION_1" | translate }}
        </p>
        <p>
          {{ "BG_DASH.DUPLICATE_IDENTITY.INSTRUCTION_2_PREFIX" | translate }}
          <span class="font-semibold text-dc-black">
            {{ "BG_DASH.DUPLICATE_IDENTITY.UPDATE_BUTTON" | translate }}
          </span>.
        </p>
        <p>
          {{ "BG_DASH.DUPLICATE_IDENTITY.ASSISTANCE" | translate }}
          <a class="font-semibold text-dc-navy underline underline-offset-4" href="mailto:customercare@dubaichamber.com">
             customercare&#64;dubaichamber.com
          </a>
        </p>
      </div>

      <label class="mt-5 flex items-center gap-3 text-base text-dc-black">
        <input
          type="checkbox"
          class="h-4 w-4 accent-dc-navy"
          [checked]="duplicateIdentityAcknowledged"
          (change)="onDuplicateIdentityAcknowledgeChange($event)"
        />
        <span class="text-sm!">
          {{ "BG_DASH.DUPLICATE_IDENTITY.ACKNOWLEDGE" | translate }}
        </span>
      </label>

        <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-center">
          <app-button
            type="button"
            classesName="btn-edge-cut min-w-[240px]"
            [label]="'BG_DASH.DUPLICATE_IDENTITY.UPDATE_BUTTON' | translate"
          (onBtnClick)="gotoProfileFromDuplicateIdentity()"
          ></app-button>
          <app-button
            type="button"
            [classesName]="
              duplicateIdentityAcknowledged
                ? 'card-edge-cut min-w-[240px]'
                : 'card-edge-cut-white min-w-[240px] opacity-50 pointer-events-none'
            "
            [label]="'BG_DASH.DUPLICATE_IDENTITY.PROCEED_BUTTON' | translate"
            (onBtnClick)="closeDuplicateIdentityModal()"
          ></app-button>
        </div>
      </div>
  </div>
}

